import {
  ButtonType,
  CrudTableViewConfig,
  CrudViewColumnType,
  ActionBehavior
} from '@rappider/rappider-components/utils';
import { PATH_DEFINITIONS } from '../../definitions/path-definition';
import { POP_CONFIRM_DELETE_ACTION } from '../pop-confirm-button/pop-confirm-button-config';

export const PAGE_LIST_CONFIG: CrudTableViewConfig = {
  defaultSearchField: 'title',
  orderable: false,
  columns: [
    {
      title: 'SHARED.ID',
      fieldName: 'id',
      visible: false,
      type: CrudViewColumnType.Text
    },
    {
      title: 'SHARED.TITLE',
      fieldName: 'title',
      type: CrudViewColumnType.Link,
      routerLink: `${PATH_DEFINITIONS.CONTENT_EDITOR.CONTENT_EDITOR_PATH}/{{id}}`,
      sortable: true
    },
    {
      title: 'SHARED.MODULE',
      fieldName: 'module.title',
      type: CrudViewColumnType.Text,
      sortable: true
    },
    {
      title: 'SHARED.PATH',
      fieldName: 'slug',
      type: CrudViewColumnType.Text
    },
    {
      title: 'SHARED.PUBLIC',
      fieldName: 'isPublic',
      type: CrudViewColumnType.Boolean
    },
    {
      title: 'SHARED.DESCRIPTION',
      fieldName: 'description',
      type: CrudViewColumnType.Text
    },
    {
      title: 'SHARED.ACTIVE',
      fieldName: 'isActive',
      type: CrudViewColumnType.Boolean
    }
  ],
  listActions: [
    {
      text: 'PAGES_MODULE.PAGE_LIST_COMPONENT.ADD_PAGE',
      buttonType: ButtonType.Default,
      behavior: ActionBehavior.Route,
      icon: { name: 'fas fa-plus' },
      redirectUrl: `${PATH_DEFINITIONS.PAGES.PAGE_CREATE_PATH}`
    }
  ],
  itemActions: [
    {
      text: 'PAGES_MODULE.PAGE_LIST_COMPONENT.DUPLICATE_PAGE',
      name: 'DUPLICATE_PAGE',
      behavior: ActionBehavior.Emit,
      icon: { name: 'fa-regular fa-copy' }
    },
    {
      text: 'PAGES_MODULE.PAGE_LIST_COMPONENT.SET_HOME_PAGE',
      name: 'SET_HOME_PAGE',
      behavior: ActionBehavior.Emit,
      icon: { name: 'far fa-home-alt' }
    },
    {
      text: POP_CONFIRM_DELETE_ACTION.text,
      name: POP_CONFIRM_DELETE_ACTION.name,
      popconfirmTitle: POP_CONFIRM_DELETE_ACTION.popconfirmTitle,
      emitWithoutPopconfirm: POP_CONFIRM_DELETE_ACTION.emitWithoutPopconfirm,
      behavior: POP_CONFIRM_DELETE_ACTION.behavior,
      icon: POP_CONFIRM_DELETE_ACTION.icon,
      popconfirmCancelText: POP_CONFIRM_DELETE_ACTION.popconfirmCancelText,
      popconfirmOkText: POP_CONFIRM_DELETE_ACTION.popconfirmOkText,
      popconfirmOkDanger: POP_CONFIRM_DELETE_ACTION.popconfirmOkDanger,
    },
    {
      text: 'SHARED.EDIT',
      behavior: ActionBehavior.Route,
      name: 'EDIT_PAGE',
      icon: { name: 'far fa-edit' },
      redirectUrl: `${PATH_DEFINITIONS.PAGES.PAGE_EDIT_PATH}/{{id}}`
    }
  ]
};
